import React from 'react'
import cx from 'classnames'
import style from './statusList.module.scss'
import { StatusItem } from '../item/StatusItem'
import { PropTypes } from 'prop-types'
import { PaymentStatus } from '../../../../resources/constants/PaymentStatus'

/**
 * List of flat cards showing list of status
 */
const StatusList = ({ history, isExpanded }) => {
	return (
		history?.length > 0 && (
			<div className={cx(style.historyList, { [style.active]: isExpanded })}>
				{history.map((status, index) => (
					<StatusItem key={index} status={status} />
				))}
			</div>
		)
	)
}

StatusList.propTypes = {
	history: PropTypes.arrayOf(
		PropTypes.shape({
			paymentStatus: PropTypes.oneOf(Object.keys(PaymentStatus)),
			/** Date of the status */
			date: PropTypes.string
		})
	),
	isExpanded: PropTypes.bool
}

export { StatusList }
